<template>
  <div class="login d-flex justify-content-center">
    <div class="mt-5 login-widget align-items-center">
      <div v-if="reasonMessage" class="alert alert-warning" role="alert">
        {{ reasonMessage }}
      </div>
      <form
        @submit.prevent="handleLogin"
        class="d-flex flex-column align-items-center"
      >
        <div class="form-group">
          <label for="username" class="pr-2">Identifiant :</label>
          <input
            type="text"
            id="username"
            required="required"
            autocomplete="username"
            v-model="username"
          />
        </div>
        <div class="form-group">
          <label for="password" class="pr-2">Mot de passe :</label>
          <input
            type="password"
            id="password"
            required="required"
            autocomplete="username"
            v-model="password"
          />
        </div>
        <div
          class="
            d-flex
            flex-column flex-lg-row
            align-items-center
            justify-content-around
            down-container
          "
        >
          <button class="btn btn-primary" type="submit">Connexion</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import auth from "../../services/auth";
// import axios from "axios";

// Raison du retour sur la page de connexion (paramètre `reason` de l'URL)
const REASON_MESSAGES = {
  SESSION_EXPIRED:
    "Votre session a expiré après une période d'inactivité. Reconnectez-vous.",
  TOKEN_BANNED:
    "Votre session a été fermée, par exemple après un changement de mot de passe. Reconnectez-vous.",
  BANNED_TOKEN:
    "Votre session a été fermée, par exemple après un changement de mot de passe. Reconnectez-vous.",
  EXPIRED_TOKEN: "Votre session a expiré. Reconnectez-vous.",
  INVALID_TOKEN: "Votre session a expiré. Reconnectez-vous.",
  DISABLED_LOGIN: "Votre compte est désactivé. Contactez un administrateur.",
  INVALID_USER: "Votre compte est désactivé. Contactez un administrateur.",
  ACCESS_DENIED:
    "Votre session a été fermée suite à une action non autorisée. Reconnectez-vous.",
};

export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  computed: {
    reasonMessage() {
      return REASON_MESSAGES[this.$route.query.reason] || null;
    },
  },
  methods: {
    handleLogin() {
      let redirect = this.$route.query.redirect || "/";
      auth
        .login(this.username, this.password)
        .then((data) => {
          this.$store.dispatch("initUser", data.user);
          this.$router.push(redirect);
        })
        .catch((error) => {
          console.log(error);
          const lockMessage = this.lockMessage(error.response);
          if (lockMessage) {
            this.$toasted.error(lockMessage).goAway(10000);
            return;
          }
          this.$toasted.error("Impossible de se connecter").goAway(3000);
          this.$toasted
            .show(
              "Vérifiez login et mot de passe ou contacter un administrateur"
            )
            .goAway(3000);
        });
    },
    // Message à afficher si les connexions sont temporairement bloquées
    // (HTTP 429), sinon null.
    lockMessage(response) {
      if (!response || response.status !== 429) {
        return null;
      }
      const data = (response.data && response.data.data) || {};
      const minutes = Math.max(1, Math.ceil((data.retry_after || 0) / 60));
      const delay = minutes > 1 ? `${minutes} minutes` : "1 minute";
      if (data.message === "TOO_MANY_ATTEMPTS_IP") {
        return (
          "Trop de tentatives de connexion échouées depuis votre réseau. " +
          `Les connexions depuis ce réseau sont bloquées pendant ${delay}. ` +
          "Si le problème persiste, contactez un administrateur."
        );
      }
      return (
        "Trop de tentatives de connexion échouées pour cet identifiant. " +
        `Il est bloqué pendant ${delay}. Réessayez plus tard ou ` +
        "contactez un administrateur."
      );
    },
  },
};
</script>

<style lang="scss">
.login-widget {
  background-color: $vue-lightest-blue;
  padding: 2rem;
}
</style>